// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollableContent_container__zk47z","content":"ScrollableContent_content__fn85q"};